import "./LanguageSelect.css";
import { useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { bindActionCreators } from "redux";
// import { actionCreators } from "../../store/index";
import { useBetween } from "use-between";

function LanguageSelect() {
  // const dispatch = useDispatch();
  // const { turnLang } = bindActionCreators(actionCreators, dispatch);
  const { locale, setLocale } = useBetween(
    useSelector((state) => state.useSharedState)
  );

  const changeLang = (e) => {
    setLocale(e.target.value);
    // turnLang(e.target.value);
  };

  return (
    <div>
      <select
        className="selectBoxLang"
        onChange={changeLang}
        name="lang"
        value={locale}
      >
        <option className="optionsMenu" value="AR">
          العربيّة
        </option>
        <option className="optionsMenu" value="EN">
          English
        </option>
        <option className="optionsMenu" value="OR">
          اردو
        </option>
        <option className="optionsMenu" value="HN">
          हिन्दी
        </option>
      </select>
    </div>
  );
}

export default LanguageSelect;
